var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"3","xs":"2","sm":"2","md":"3"}}),_c('v-col',{attrs:{"cols":"6","xs":"8","sm":"8","md":"6"}},[_c('v-app-bar-title',[_vm._v("ADMIN")])],1)],1),_c('AdminMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }